import React from 'react';
import styled from 'styled-components';
import ChartView from './ChartView';
import { ChartMode } from './types';
import { analysisAiScreenshotDivElementId } from '../ExplainWithAi';

interface IProps {
  mode: ChartMode;
  analysisId: string;
}

const Container = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 0;
  row-gap: var(--chart-row-gap, '12px');
  // do not break the chart in the middle when printing
  @media print {
    break-inside: avoid;
  }
`;

// IMPORTANT:
// Due to a usage in TopPathFunnelChart,
// we can't use chartContext in this component
const ChartWrapper = ({ analysisId, mode }: IProps) => {
  // Do NOT remove this ID otherwise you will break the AI screenshots
  return (
    <Container id={analysisAiScreenshotDivElementId(analysisId)}>
      <ChartView analysisId={analysisId} mode={mode} />
    </Container>
  );
};

export default ChartWrapper;
